<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark"><i class="nav-icon fas fa-user-chart"></i> Comissões <small>Formulário de Cadastro</small></h1>
                    </div>
                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active"><i class="nav-icon fas fa-user-chart"></i> Comissões</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline">
                    <form id="form1" class="form-horizontal">
                        <div class="card-header">
                            <h3 class="card-title"><i class="fad fa-arrow-circle-right"></i> Dados da Comissão</h3>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="invoice col-md-12" style="margin-bottom: 20px;">
                                    <div class="row">
                                        <div class="col-12">
                                            <h4>
                                                <i class="fas fa-globe"></i> {{ entity.empreendimento }}
                                                <small class="float-right">Data Contrato: {{ entity.data_contrato | formatDate }}</small>
                                            </h4>
                                        </div>
                                    </div>
                                    <div class="row invoice-info">
                                        <div class="col-sm-4 invoice-col">
                                            <strong>Cliente:</strong> {{ entity.cliente }} <br><br>
                                        </div>
                                        <div class="col-sm-4 invoice-col">
                                            <strong>Valor Contrato:</strong> R$ {{ entity.valor_venda }} <br><br>
                                        </div>
                                        <div class="col-sm-4 invoice-col">
                                            <strong>Entrada Recebida:</strong> R$ {{ entity.valor_entrada }} <br><br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4" v-if="entity.comissao_vendedor_total">
                                    <div class="card card-widget widget-user-2 shadow-sm">
                                        <div class="widget-user-header bg-warning">
                                            <h3 :title="entity.vendedor_parceiro" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ entity.vendedor_parceiro }}</h3>
                                            <h5>VENDEDOR</h5>
                                        </div>
                                        <div class="card-footer p-0">
                                            <ul class="nav flex-column">
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO SINAL <span class="float-right badge bg-primary">{{ entity.comissao_vendedor_p_sinal }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO VGV <span class="float-right badge bg-info">{{ entity.comissao_vendedor_p_vgv }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL SINAL <span class="float-right badge bg-primary">{{ entity.comissao_vendedor_v_sinal }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL VGV <span class="float-right badge bg-info">{{ entity.comissao_vendedor_v_vgv }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR TOTAL <span class="float-right badge bg-success">{{ entity.comissao_vendedor_total }} R$</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="entity.comissao_parceiro_total">
                                    <div class="card card-widget widget-user-2 shadow-sm">
                                        <div class="widget-user-header bg-warning">
                                            <h3 :title="entity.supervisor_coord_parc" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ entity.vendedor_parceiro }}</h3>
                                            <h5>SUPERV. / COORD. PARC.</h5>
                                        </div>
                                        <div class="card-footer p-0">
                                            <ul class="nav flex-column">
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO SINAL <span class="float-right badge bg-primary">{{ entity.comissao_parceiro_p_sinal }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO VGV <span class="float-right badge bg-info">{{ entity.comissao_parceiro_p_vgv }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL SINAL <span class="float-right badge bg-primary">{{ entity.comissao_parceiro_v_sinal }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL VGV <span class="float-right badge bg-info">{{ entity.comissao_parceiro_v_vgv }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR TOTAL <span class="float-right badge bg-success">{{ entity.comissao_parceiro_total }} R$</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="entity.valor_comissao">
                                    <div class="card card-widget widget-user-2 shadow-sm">
                                        <div class="widget-user-header bg-danger">
                                            <h3 :title="entity.razao_social_venda_parceria" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ entity.razao_social_venda_parceria }}</h3>
                                            <h5>PARCEIRO</h5>
                                        </div>
                                        <div class="card-footer p-0">
                                            <ul class="nav flex-column">
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO SINAL <span class="float-right badge bg-primary">NA</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO VGV <span class="float-right badge bg-info">NA</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL SINAL <span class="float-right badge bg-primary">NA</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL VGV <span class="float-right badge bg-info">NA</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR TOTAL <span class="float-right badge bg-success">{{ entity.valor_comissao }} R$</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="entity.comissao_gerente_total">
                                    <div class="card card-widget widget-user-2 shadow-sm">
                                        <div class="widget-user-header bg-info">
                                            <h3 :title="entity.gerente" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ entity.gerente }}</h3>
                                            <h5>GERENTE</h5>
                                        </div>
                                        <div class="card-footer p-0">
                                            <ul class="nav flex-column">
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO SINAL <span class="float-right badge bg-primary">{{ entity.comissao_gerente_p_sinal }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO VGV <span class="float-right badge bg-info">{{ entity.comissao_gerente_p_vgv }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL SINAL <span class="float-right badge bg-primary">{{ entity.comissao_gerente_v_sinal }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL VGV <span class="float-right badge bg-info">{{ entity.comissao_gerente_v_vgv }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR TOTAL <span class="float-right badge bg-success">{{ entity.comissao_gerente_total }} R$</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-4" v-if="entity.comissao_superintendente_total">
                                    <div class="card card-widget widget-user-2 shadow-sm">
                                        <div class="widget-user-header bg-success">
                                            <h3 :title="entity.gestor" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ entity.gestor }}</h3>
                                            <h5>SUPERINTENDENTE</h5>
                                        </div>
                                        <div class="card-footer p-0">
                                            <ul class="nav flex-column">
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO SINAL <span class="float-right badge bg-primary">{{ entity.comissao_superintendente_p_sinal }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        % COMISSÃO VGV <span class="float-right badge bg-info">{{ entity.comissao_superintendente_p_vgv }} %</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL SINAL <span class="float-right badge bg-primary">{{ entity.comissao_superintendente_v_sinal }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR DA COMISSÃO INTEGRAL VGV <span class="float-right badge bg-info">{{ entity.comissao_superintendente_v_vgv }} R$</span>
                                                    </a>
                                                </li>
                                                <li class="nav-item">
                                                    <a href="#" class="nav-link">
                                                        VALOR TOTAL <span class="float-right badge bg-success">{{ entity.comissao_superintendente_total }} R$</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </form>
                    <div class="card-footer">
                        <button type="button" v-on:click="back" class="btn btn-default btn-social"><i class="fas fa-history"></i> Voltar</button>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>
        <!-- /.content -->
    </div>
</template>

<script>
import ComissaoController from "@/controllers/comissao.controller";

export default {
    data: function () {
        return {
            entity: {}
        };
    },
    mounted() {
        const id = parseInt(this.$route.params.id, 10);
        this.loadEntity(id);
    },
    methods: {
        loadEntity: function (id) {

            if (id === 0)
                return;

            ComissaoController.getRelatorioById(id)
                .then(response => {
                    this.entity = response.data.result;
                });
        },
        back: function () {
            this.$router.push({ name: "list-comissao" });
        }
    }
};
</script>

<style scoped>
</style>